import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=623fa773&scoped=true"
import script from "./eventList.vue?vue&type=script&lang=ts"
export * from "./eventList.vue?vue&type=script&lang=ts"
import style0 from "./eventList.vue?vue&type=style&index=0&id=623fa773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623fa773",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDivider,VList,VListItem,VListItemContent,VListItemGroup,VListItemSubtitle,VListItemTitle})
